import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=30c6fc1a&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=30c6fc1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6fc1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c6fc1a')) {
      api.createRecord('30c6fc1a', component.options)
    } else {
      api.reload('30c6fc1a', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=30c6fc1a&scoped=true", function () {
      api.rerender('30c6fc1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/orderDetail.vue"
export default component.exports